import type { WidgetPreset } from "../types";
import { FONT } from "../types";
import templateHtml from "./template.html?raw";

export const DRAFT_STAMP: WidgetPreset = {
  id: "draft-stamp",
  label: "DRAFT stamp",
  defaultWidth: 160,
  defaultHeight: 80,
  html: templateHtml.replaceAll("__FONT__", FONT),
};
